const dataPhotocard = {
    0: [
        {
            "name": "Ralph Theodoric Adam",
            "jabatan": "Supervisor",
            "bgcolor": `linear-gradient(180deg, #4774CA 0%, #033488 100%)`,
            "foto1": "./Assets/PhotocardDivisi/gandara/Photocard1A.png",
            "foto2": "./Assets/PhotocardDivisi/gandara/Photocard1B.png",
        },
        {
            "name": "Wilcoustine Qhrismast Pniel",
            "jabatan": "Ketua",
            "bgcolor": `linear-gradient(180deg, #4774CA 0%, #033488 100%)`,
            "foto1": "./Assets/PhotocardDivisi/gandara/Photocard2A.png",
            "foto2": "./Assets/PhotocardDivisi/gandara/Photocard2B.png",
        },
        {
            "name": "Jehezkiel Immanuel",
            "jabatan": "Wakil Ketua",
            "bgcolor": `linear-gradient(180deg, #4774CA 0%, #033488 100%)`,
            "foto1": "./Assets/PhotocardDivisi/gandara/Photocard3A.png",
            "foto2": "./Assets/PhotocardDivisi/gandara/Photocard3B.png",
        },
        {
            "name": "Cecillia Abbygail",
            "jabatan": "Sekretaris 1",
            "bgcolor": `linear-gradient(180deg, #4774CA 0%, #033488 100%)`,
            "foto1": "./Assets/PhotocardDivisi/gandara/Photocard4A.png",
            "foto2": "./Assets/PhotocardDivisi/gandara/Photocard4B.png",
        },
        {
            "name": "Ida Ayu Tretami",
            "jabatan": "Sekretaris 2",
            "bgcolor": `linear-gradient(180deg, #4774CA 0%, #033488 100%)`,
            "foto1": "./Assets/PhotocardDivisi/gandara/Photocard5A.png",
            "foto2": "./Assets/PhotocardDivisi/gandara/Photocard5B.png",
        },
        {
            "name": "Assyifa Salsabila",
            "jabatan": "Bendahara",
            "bgcolor": `linear-gradient(180deg, #4774CA 0%, #033488 100%)`,
            "foto1": "./Assets/PhotocardDivisi/gandara/Photocard6A.png",
            "foto2": "./Assets/PhotocardDivisi/gandara/Photocard6B.png",
        },
    ],
    8: [
        {
            "name": "Daffa Akbari",
            "jabatan": "Koordinator",
            "bgcolor": "#FDDD48",
            "bgtext": "./Assets/PhotocardDivisi/element/bg_ui.png", 
            "foto1": "./Assets/PhotocardDivisi/nayanika/Photocard1A.png",
            "foto2": "./Assets/PhotocardDivisi/nayanika/Photocard1B.png",
        },
        {
            "name": "Jose Andreas",
            "jabatan": "Koordinator",
            "bgcolor": "#FDDD48",
            "bgtext": "./Assets/PhotocardDivisi/element/bg_fe.png",
            "foto1": "./Assets/PhotocardDivisi/nayanika/Photocard2A.png",
            "foto2": "./Assets/PhotocardDivisi/nayanika/Photocard2B.png",
        },
        {
            "name": "Axel Ferdinand",
            "jabatan": "Anggota",
            "bgcolor": "#FDDD48",
            "bgtext": "./Assets/PhotocardDivisi/element/bg_fe.png",
            "foto1": "./Assets/PhotocardDivisi/nayanika/Photocard3A.png",
            "foto2": "./Assets/PhotocardDivisi/nayanika/Photocard3B.png",
        },
        {
            "name": "Caleb Steve",
            "jabatan": "Anggota",
            "bgcolor": "#FDDD48",
            "bgtext": "./Assets/PhotocardDivisi/element/bg_ui.png",
            "foto1": "./Assets/PhotocardDivisi/nayanika/Photocard8A.png",
            "foto2": "./Assets/PhotocardDivisi/nayanika/Photocard8B.png",
        },
        {
            "name": "Deswandy Wong",
            "jabatan": "Anggota",
            "bgcolor": "#FDDD48",
            "bgtext": "./Assets/PhotocardDivisi/element/bg_fe.png",
            "foto1": "./Assets/PhotocardDivisi/nayanika/Photocard7A.png",
            "foto2": "./Assets/PhotocardDivisi/nayanika/Photocard7B.png",
        },
        {
            "name": "Kafijaya",
            "jabatan": "Anggota",
            "bgcolor": "#FDDD48",
            "bgtext": "./Assets/PhotocardDivisi/element/bg_fe.png",
            "foto1": "./Assets/PhotocardDivisi/nayanika/Photocard4A.png",
            "foto2": "./Assets/PhotocardDivisi/nayanika/Photocard4B.png",
        },
        {
            "name": "Kevin Ken",
            "jabatan": "Anggota",
            "bgcolor": "#FDDD48",
            "bgtext": "./Assets/PhotocardDivisi/element/bg_fe.png",
            "foto1": "./Assets/PhotocardDivisi/nayanika/Photocard5A.png",
            "foto2": "./Assets/PhotocardDivisi/nayanika/Photocard5B.png",
        },
        {
            "name": "Valentino Fernando",
            "jabatan": "Anggota",
            "bgcolor": "#FDDD48",
            "bgtext": "./Assets/PhotocardDivisi/element/bg_ui.png",
            "foto1": "./Assets/PhotocardDivisi/nayanika/Photocard6A.png",
            "foto2": "./Assets/PhotocardDivisi/nayanika/Photocard6B.png",
        },
    ],
    3: [
        {
            "name": "Gabrielle Claudia",
            "jabatan": "Koordinator",
            "foto": "./Assets/Photocard/lavanya/SwiperAnggota1A.png",
        },
        {
            "name": "Jessica Marella",
            "jabatan": "Koordinator",
            "foto": "./Assets/Photocard/lavanya/SwiperAnggota2A.png",
        },
        {
            "name": "David Wang",
            "jabatan": "Anggota",
            "foto": "./Assets/Photocard/lavanya/SwiperAnggota3A.png",
        },
        {
            "name": "Qonita Azalia",
            "jabatan": "Anggota",
            "foto": "./Assets/Photocard/lavanya/SwiperAnggota4A.png",
        },
        {
            "name": "Rara Anggreni",
            "jabatan": "Anggota",
            "foto": "./Assets/Photocard/lavanya/SwiperAnggota5A.png",
        },
        {
            "name": "Ruus, Auliana",
            "jabatan": "Anggota",
            "foto": "./Assets/Photocard/lavanya/SwiperAnggota6A.png",
        },
        {
            "name": "Stacyana Susanto",
            "jabatan": "Anggota",
            "foto": "./Assets/Photocard/lavanya/SwiperAnggota7A.png",
        },
    ],
    5: [
        {
            "name": "Ravalen Virginia",
            "jabatan": "Koordinator",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard1A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard1B.png",
        },
        {
            "name": "Allison Gressia",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/camera.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard2A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard2B.png",
        },
        {
            "name": "Andrew Su",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/camera.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard3A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard3B.png",
        },
        {
            "name": "Ari Sastra",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/video.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard4A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard4B.png",
        },
        {
            "name": "Darren",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/video.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard5A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard5B.png",
        },
        {
            "name": "Diana Angyulia",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/camera.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard6A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard6B.png",
        },
        {
            "name": "Elizabeth Larasati",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/video.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard7A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard7B.png",
        },
        {
            "name": "Fauzan Habrari",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/video.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard8A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard8B.png",
        },
        {
            "name": "Kristian Delon",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/camera.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard9A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard9B.png",
        },
        {
            "name": "Maria Cahaya",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/camera.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard10A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard10B.png",
        },
        {
            "name": "Maria Oxa",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/camera.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard11A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard11B.png",
        },
        {
            "name": "Qhedyzya Ricardiane",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/camera.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard12A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard12B.png",
        },
        {
            "name": "Rama Yoga",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/video.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard13A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard13B.png",
        },
        {
            "name": "Rava Parisya",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/video.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard14A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard14B.png",
        },
        {
            "name": "Rether",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/camera.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard15A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard15B.png",
        },
        {
            "name": "Sakti Yudha",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/video.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard16A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard16B.png",
        },
        {
            "name": "Salman Aqil",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/camera.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard17A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard17B.png",
        },
        {
            "name": "Steven Hans",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/camera.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard18A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard18B.png",
        },
        {
            "name": "Valentino K",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/camera.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard19A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard19B.png",
        },
        {
            "name": "Yohanes Govinda",
            "jabatan": "Anggota",
            "bgcolor": `linear-gradient(180deg, #FFB560 0%, #FF7E0B 100%)`,
            "bgbaskara": './Assets/PhotocardDivisi/element/video.png',
            "foto1": "./Assets/PhotocardDivisi/baskara/Photocard20A.png",
            "foto2": "./Assets/PhotocardDivisi/baskara/Photocard20B.png",
        },
    ],
    2: [
        {
            "name": "Afiq Walid",
            "jabatan": "Koordinator",
            "foto": "./Assets/Photocard/caksana/SwiperAnggota1A.png",
        },
        {
            "name": "Divi Afrilia",
            "jabatan": "Koordinator",
            "foto": "./Assets/Photocard/caksana/SwiperAnggota2A.png",
        },
        {
            "name": "Beatrice Ellena",
            "jabatan": "Anggota",
            "foto": "./Assets/Photocard/caksana/SwiperAnggota3A.png",
        },
        {
            "name": "Cherish Dominick",
            "jabatan": "Anggota",
            "foto": "./Assets/Photocard/caksana/SwiperAnggota4A.png",
        },
        {
            "name": "Ferdi Julius",
            "jabatan": "Anggota",
            "foto": "./Assets/Photocard/caksana/SwiperAnggota5A.png",
        },
        {
            "name": "Gabriela Salim",
            "jabatan": "Anggota",
            "foto": "./Assets/Photocard/caksana/SwiperAnggota6A.png",
        },
        {
            "name": "Lawrencia",
            "jabatan": "Anggota",
            "foto": "./Assets/Photocard/caksana/SwiperAnggota7A.png",
        },
        {
            "name": "Paramitha Irgina",
            "jabatan": "Anggota",
            "foto": "./Assets/Photocard/caksana/SwiperAnggota8A.png",
        },
        {
            "name": "Rachel Natalie",
            "jabatan": "Anggota",
            "foto": "./Assets/Photocard/caksana/SwiperAnggota9A.png",
        },
        {
            "name": "Silvia Andriyani",
            "jabatan": "Anggota",
            "foto": "./Assets/Photocard/caksana/SwiperAnggota10A.png",
        },
        {
            "name": "Stefani Margaretha",
            "jabatan": "Anggota",
            "foto": "./Assets/Photocard/caksana/SwiperAnggota11A.png",
        },
    ],
}

export default dataPhotocard;